import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import VConsole from 'vconsole';
import { store } from './store';
import { router } from './router';
import { ICPFooter } from './components/common/ICPFooter';
import { APP_CONFIG } from './config/appConfig';
import { clearStaleClientCaches } from './utils/clearStaleClientCaches';
import './index.css';

// 仅在移动端或 URL 包含 ?debug=true 时开启调试面板
if (import.meta.env.DEV && (window.innerWidth < 768 || window.location.search.includes('debug=true'))) {
  new VConsole();
}

void clearStaleClientCaches();

document.title = APP_CONFIG.appName;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <div className="min-h-screen pb-8">
        <RouterProvider router={router} />
      </div>
      <ICPFooter />
    </Provider>
  </React.StrictMode>
);
